/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 17/11/2023
 */

import React from 'react';
import { LayoutProps, RankedTester, rankWith, uiTypeIs } from '@jsonforms/core';
import { LabelElement } from '@jsonforms/core/src/models/uischema';
import { withNamedJsonFormsLayoutProps } from '@/forms-renderers/chakra-ui/utils/withNamedJsonFormsHOC';
import { namedMemo } from '@/utils/namedMemo';
import InfoTooltip from '@/components/Tooltip/InfoTooltip';

export const ChakraTooltipRenderer = namedMemo('ChakraLabelRenderer', ({ uischema, visible }: LayoutProps) => {
    const element = uischema as LabelElement & { label?: string };

    if (visible) {
        return <InfoTooltip tooltipLabel={element.label ? element.label : 'tooltip'} tooltipInfoText={element.text} />;
    } else {
        return null;
    }
});

export const chakraTooltipRendererTester: RankedTester = rankWith(1, uiTypeIs('Tooltip'));

export default withNamedJsonFormsLayoutProps(ChakraTooltipRenderer);
